<template>
	<div>
		<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
			<div class="row">
				<div class="col-md-12 text-right">
					<!-- <a-button class="btn btn-warning" icon="file" @click="sendStockReport('all')" v-if="usersAllowed">Enviar reporte de existencias</a-button> -->
					<a-button class="btn btn-info ml7" icon="plus" @click="onAddRecord">Añadir</a-button>
					<a-button class="btn btn-success ml7" icon="reload" @click="onReload" />
					<!-- <div v-if="usersAllowed && lastNotification.created_at">
						<small>Último envío general de lista de precios: {{ moment(lastNotification.created_at).subtract(6, 'hours').format('DD-MM-YYYY HH:mm') }} hrs.</small>
					</div> -->
				</div>
			</div>
			<div class="row pt15">
				<div class="col-md-12">
					<a-input allowClear v-model="searchText" @change="onSearch" placeholder="Búsqueda en clientes..." />
				</div>
				<div class="col-md-12 pt10">
					<a-table :columns="columns" :dataSource="searchText == '' ? customersList : customersListFiltered" :pagination="{ pageSize: 25 }">
						<div slot="index" slot-scope="record">
							{{ record.index }}
						</div>
						<div slot="full_name" slot-scope="record">
							<div>(#{{ record.id }}) - {{ record.full_name }}</div>
							<div>
								<b>{{ clientTypes[record.customer_type] }}</b>
							</div>
							<a-tag color="yellow" v-if="record.price_list == 'ORO'">ORO</a-tag>
							<a-tag color="gray" v-if="record.price_list == 'PLATA'">PLATA</a-tag>
							<a-tag color="orange" v-if="record.price_list == 'BRONCE'">BRONCE</a-tag>
						</div>
						<div slot="customer_info" slot-scope="record">
							<div>{{ record.phone }}</div>
							<div>{{ record.email }}</div>
							<div v-if="record.lastNotification"><b style="color: green">Última notificación:</b> {{ moment(record.lastNotification).subtract(6, 'hours').format('DD-MM-YYYY HH:mm') }} hrs.</div>
						</div>

						<div slot="action" slot-scope="record">
							<!-- <a-tooltip placement="top">
								<template slot="title"> Enviar lista de disponibles </template>
								<a-button type="info" size="small" icon="file" @click="sendStockReport(record.id)" v-if="usersAllowed" />
							</a-tooltip> -->
							<a-tooltip placement="top">
								<template slot="title"> Editar registro </template>
								<a-button type="info ml7" size="small" icon="edit" @click="onEditRecord(record.id)" />
							</a-tooltip>
							<a-tooltip placement="top">
								<template slot="title"> Deshabilitar registro </template>
								<a-button class="ml7" size="small" :icon="record.active ? 'minus-circle' : 'plus-circle'" @click="toggleRecord(record.id)" />
							</a-tooltip>
						</div>
					</a-table>
				</div>
			</div>
		</a-spin>
	</div>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import _ from 'lodash'
import moment from 'moment-timezone'
import { clientTypes } from '@/constants'

export default {
	name: 'customersView',
	data() {
		return {
			clientTypes,
			searchText: '',
			customersListFiltered: [],
			lastNotification: {},
		}
	},
	computed: {
		...mapGetters('user', ['user']),
		...mapGetters('customers', ['customersList', 'spinnerLoader', 'spinnerLoaderLabel']),
		columns() {
			let columns = [
				{
					title: '#',
					scopedSlots: { customRender: 'index' },
					align: 'center',
					width: '10%',
				},
				{
					title: 'Nombre',
					scopedSlots: { customRender: 'full_name' },
					width: '45%',
				},
				{
					title: 'Información de contacto',
					scopedSlots: { customRender: 'customer_info' },
					width: '30%',
				},
				{
					title: 'Acciones',
					scopedSlots: { customRender: 'action' },
					align: 'right',
					width: '15%',
				},
			]
			return columns
		},
		usersAllowed() {
			return [1, 2, 3].includes(this.user.user_id)
		},
	},
	mounted() {
		this.initModule()
	},
	methods: {
		moment,
		initModule() {
			let payload = {}
			this.$store.dispatch('customers/GET', payload).then((response) => {
				// console.log('customers/GET', response)
				this.lastNotification = _.cloneDeep(response.lastNotification)
			})
		},
		onReload() {
			this.initModule()
		},
		onAddRecord() {
			this.$router.push('/customers/new')
		},
		sendStockReport(customer_id) {
			// console.log('sendStockReport-->', id)
			Swal.fire({
				title: 'Atención',
				html: 'Estás por enviar la lista de precios, ¿Deseas continuar?',
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonText: 'Sí, continuar',
				cancelButtonText: 'Cancelar',
			}).then((result) => {
				if (result.isConfirmed) {
					this.$store
						.dispatch('warehouse/SEND_STOCK_REPORT', {
							customer_id,
						})
						.then(() => {
							this.initModule()
						})
				}
			})
		},
		onEditRecord(id) {
			this.$store.dispatch('customers/GET_ONE', id).then(() => {
				this.$router.push(`/customers/${id}`)
			})
		},
		toggleRecord(id) {
			Swal.fire({
				title: 'Atención',
				html: '¿Desea deshabilitar el registro?',
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonText: 'Sí, continuar',
				cancelButtonText: 'Cancelar',
			}).then((result) => {
				if (result.isConfirmed) {
					this.$store.dispatch('customers/TOGGLE', {
						section: 'customers',
						id,
					})
				}
			})
		},
		onSearch(event) {
			let { value } = event.target
			this.customersListFiltered = []
			if (value != '') {
				this.customersListFiltered = this.customersList.filter((obj) =>
					Object.values(obj).some((val) => {
						if (typeof val == 'string' && val.toLowerCase().includes(value.toLowerCase())) {
							return true
						}
					}),
				)
			}
		},
	},
}
</script>